module.exports = __webpack_public_path__ + "static/media/blue.62ee83f8.svg";